import { render, staticRenderFns } from "./groupWork.vue?vue&type=template&id=58ded93c&scoped=true"
import script from "./groupWork.vue?vue&type=script&lang=js"
export * from "./groupWork.vue?vue&type=script&lang=js"
import style0 from "./groupWork.vue?vue&type=style&index=0&id=58ded93c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ded93c",
  null
  
)

export default component.exports